<template>
  <div class="container">
    <PublicHeader :totalName="$t('common').Activecenter" />
    <img class="topimg" src="@/assets/img/activity_auth.png" />
    <div class="content ql-editor" v-html="$t('activity').authRewardTxt"></div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
    }
  },

  mounted() {
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding: 60px 15px 15px 15px;

  .topimg {
    width: 100%;
  }

  .content {
    margin-top: 15px;
    font-size: 14px;
    color: var(--text_color);
    line-height: 25px;
    white-space: pre-wrap;
  }
}
</style>
